module.exports = __webpack_public_path__ + "static/media/meta.af6f4033.jpg";